import React from 'react';
import Hero from './components/holidays-list/Hero';
import Main from './components/holidays-list/Main';

const HolidaysList = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default HolidaysList;